import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p className={styles.text}>&copy; Ionut Stoleriu, 2026</p>
    </footer>
  );
};

export default Footer;